"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyCard = void 0;
const react_1 = __importDefault(require("react"));
const classFunctions_1 = require("../../../utils/classFunctions");
require("./index.scss");
const className = 'company-card';
class CompanyCard extends react_1.default.PureComponent {
    render() {
        const { image, name, city, duration, modificators } = this.props;
        const classNames = (0, classFunctions_1.getClassNames)(className, modificators);
        return (react_1.default.createElement("div", { className: classNames },
            react_1.default.createElement("div", { className: `${className}__container` },
                react_1.default.createElement("div", { className: `${className}__image` },
                    react_1.default.createElement("img", { src: image, alt: name })),
                react_1.default.createElement("div", { className: `${className}__content` },
                    react_1.default.createElement("div", { className: `${className}__name` }, name),
                    react_1.default.createElement("p", { className: `${className}__city` }, city),
                    react_1.default.createElement("p", { className: `${className}__duration` }, duration)))));
    }
}
exports.CompanyCard = CompanyCard;
CompanyCard.defaultProps = {
    image: null,
    name: null,
    city: null,
    duration: null,
};
//# sourceMappingURL=index.js.map